import AssessmentHistoryTable from './AssessmentHistoryTable';
import ClaimHistoryTable from './ClaimHistoryTable';
import SupervisionHistoryTable from './SupervisionHistoryTable';
import { HistoricalDocuments } from '../../../../pages/constants';
import SessionHistoryTable from './SessionsHistoryTable';
import InvoiceHistoryTable from './InvoiceHistoryTable';
import QuestionnaireHistoryTable from './QuestionnaireHistoryTable';
import { useHistoryTablesData } from './hooks';

import type { IOption } from '../../../../utils/types';

interface HistoryTablesProps {
  selectedDocument: IOption | null;
}

function HistoryTables({ selectedDocument }: HistoryTablesProps) {
  const {
    claimList,
    assessmentList,
    clientSNList,
    btSNList,
    parentSNList,
    groupSNList,
    sessions,
    invoices,
    onboardingQuestionnaires,
    intakeQuestionnaires,
  } = useHistoryTablesData();

  const getTable = (selectedDocument: IOption | null) => {
    if (!selectedDocument) return null;
    switch (selectedDocument?.id) {
      case HistoricalDocuments.Assessment:
        return (
          <AssessmentHistoryTable
            data={assessmentList}
            documentType={HistoricalDocuments.Assessment}
          />
        );
      case HistoricalDocuments.BTSupervision:
        return (
          <SupervisionHistoryTable
            data={btSNList}
            documentType={HistoricalDocuments.BTSupervision}
          />
        );
      case HistoricalDocuments.Claim:
        return <ClaimHistoryTable data={claimList} documentType={HistoricalDocuments.Claim} />;

      case HistoricalDocuments.ClientSupervision:
        return (
          <SupervisionHistoryTable
            data={clientSNList}
            documentType={HistoricalDocuments.ClientSupervision}
          />
        );
      case HistoricalDocuments.GroupSupervision:
        return (
          <SupervisionHistoryTable
            data={groupSNList}
            documentType={HistoricalDocuments.GroupSupervision}
          />
        );
      case HistoricalDocuments.ParentSupervision:
        return (
          <SupervisionHistoryTable
            data={parentSNList}
            documentType={HistoricalDocuments.ParentSupervision}
          />
        );
      case HistoricalDocuments.Session:
        return <SessionHistoryTable data={sessions} documentType={HistoricalDocuments.Session} />;
      case HistoricalDocuments.Invoice:
        return (
          <InvoiceHistoryTable
            data={invoices.invoices}
            documentType={HistoricalDocuments.Invoice}
          />
        );
      case HistoricalDocuments.Questionnaire:
        return (
          <QuestionnaireHistoryTable
            onboardingQuestionnaires={onboardingQuestionnaires}
            intakeQuestionnaires={intakeQuestionnaires}
            documentType={HistoricalDocuments.Questionnaire}
          />
        );
      default:
        break;
    }
  };

  return <>{getTable(selectedDocument ?? null)}</>;
}

export default HistoryTables;
